import { render, staticRenderFns } from "./NutrientMapList.vue?vue&type=template&id=081f6b5e&scoped=true&lang=html&"
import script from "./NutrientMapList.vue?vue&type=script&lang=js&"
export * from "./NutrientMapList.vue?vue&type=script&lang=js&"
import style0 from "./NutrientMapList.vue?vue&type=style&index=0&id=081f6b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f6b5e",
  null
  
)

export default component.exports